@if (displayHelp && helpAlias) {
  <button mat-raised-button (click)="showHelp()">
    <mat-icon svgIcon="help"></mat-icon>
    <span>{{ 'generic.getting_started' | translate}}</span>
  </button>
}
